module.exports = __webpack_public_path__ + "img/pigai-icon-01.a8505b9e.png";